import type {
	Task,
	TaskListEnrichmentFieldsFragment,
} from '@/generated/graphql';

export const getTaskEnrichmentData = (
	taskId: Task['id'],
	tasksEnrichmentData:
		| Map<Task['id'], TaskListEnrichmentFieldsFragment>
		| null
		| undefined,
	newlyAddedTaskIds?: Set<Task['id']>
): TaskListEnrichmentFieldsFragment | null | undefined => {
	// If this is a newly added task, return undefined to trigger fallback query
	if (newlyAddedTaskIds?.has(taskId)) {
		return undefined;
	}

	// Expecting tasksEnrichmentData to be passed down (loading state)
	if (tasksEnrichmentData === null) {
		return null;
	}

	if (tasksEnrichmentData === undefined) {
		return undefined;
	}

	return tasksEnrichmentData.get(taskId) ?? null;
};
